import script from "./AboutSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./AboutSection.vue?vue&type=script&lang=ts&setup=true"

import "./AboutSection.vue?vue&type=style&index=0&id=2afdc248&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2afdc248"]])

export default __exports__